// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();
	site.nav.init();
	//site.responsive.tables();
	site.responsive.videos();
	site.divisionPicker.init();
	site.tables.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	
});
